
import React from 'react';
import { useLocation } from 'react-router-dom';
import sanitizeHtml from 'sanitize-html'; // Import sanitize-html

const api_url = process.env.REACT_APP_API_URL;

const BlogDetails = () => {
  const location = useLocation();
  const newsItem = location.state;

  // Sanitize the content to remove unwanted HTML for display
  const sanitizedContent = sanitizeHtml(newsItem.content, {
    allowedTags: ['b', 'i', 'em', 'strong', 'a', 'p', 'br'], // Customize allowed tags
    allowedAttributes: {
      'a': ['href', 'target', 'rel'], // Customize allowed attributes for links
    },
  });

  return (
    <>
      <section className="blog-details" style={{ minHeight: '100vh', marginTop: '200px' }}>
        <div className="auto-container">
          <div className="row">
            <div className="col-lg-8 content-side">
              <div className="blog-details-content">
                <div className="upper-box" style={{ display: 'flex', alignItems: 'center' }}>
                  <div className="col-lg-6 news-block-two" style={{ flex: '0 0 50%' }}>
                    <div className="inner-box">
                      {newsItem.image && (
                        <img
                          src={`${api_url}/${newsItem.image}`}
                          alt={newsItem.title}
                          style={{ maxWidth: '100%', height: 'auto' }}
                        />
                      )}
                    </div>
                  </div>
                  <div className="info" style={{ flex: '0 0 50%' }}>
                    <ul className="post-meta">
                      <h3>{newsItem.title}</h3>
                      <li>{new Date(newsItem.created_at).toLocaleDateString()}</li>
                    </ul>
                  </div>
                </div>
                <div className="content-box">
                  {/* Use sanitized content for display */}
                  <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
                </div>
              </div>
            </div>
            <div className="col-lg-4 sidebar-side">
              {/* Sidebar content can be added here */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;